import React from "react"

import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell"
import myTime_setTimeReport from "../../../../../../../app/home/my-time/daily/actions/change-time-report"
import FieldProto_updateView from "../../../../../proto/render/table/function/update-view"
import FieldTimeSpent from "../../../../../generic/datetime/time-spent/time-spent"
import FieldTimeReported_Editable from "../../../../../generic/datetime/time-spent/render/my-time/editable"

// const debug = "FieldTimeReportMinutes_TableCell"
const debug = false

export default function FieldTimeReportMinutes_TableCell(props: FieldTableCellProps): React.ReactElement {
    const timeReport = props.listItem.timeReport

    if (props.manager.isReadOnly) {
        const minutes       = timeReport?.reportedTimeMinutes || timeReport?.estimatedTimeMinutes
        const isGuesstimate = timeReport?.isGuesstimate
        return (
            <div className  = "cell-flex"
                 style      = {getTableCellStyle(props)}
            >
                <div className={Classes("ui5-field-editable size-small min-w-110", {
                    'ui5-txt-less-important-small' : !!minutes,
                    'ui5-txt-no-accent-small'      : !minutes || isGuesstimate
                })}>
                    {isGuesstimate && <span>~</span>}
                    {minutes ? props.field.getDisplayValue(minutes) : ""}
                </div>
            </div>
        )
    }

    const onChange = async (reportedTimeMinutes: number | null, startMoment?: Moment | null, endMoment?: Moment | null) => {
        if (reportedTimeMinutes === null) {
            return
        }

        debug && console.log(debug, 'onChange', reportedTimeMinutes, startMoment, endMoment)

        // await myTime_setTimeReport(reportedTimeMinutes, timeReport.id, startMoment, endMoment)
        props.listItem.updateLastUpdateTime()
        FieldProto_updateView(props.manager, props.field)
    }

    debug && console.log(debug, 'render', timeReport, props.listItem.debugName)

    return (
        <div className  = "cell-flex"
             style      = {getTableCellStyle(props)}
        >
            <FieldTimeReported_Editable
                key         = {timeReport.reportedTimeMinutes ?? 0}
                className   = "w-100-percent h-100-percent"
                field       = {props.field as FieldTimeSpent}
                model       = {timeReport}
                onChange    = {onChange}
            />
        </div>
    )
}
